export const SupplierData =[
    {
      id: "1",
      supplierName: "Apex Computers",
      code: "201",
      email: "apexcomputers@example.com",
      phone: "+12163547758",
      country: "Germany",
      image: "assets/img/supplier/supplier-01.png",
      status:"Active",
    },
    {
      id: "2",
      supplierName: "Beats Headphones",
      code: "202",
      email: "beatsheadphones@example.com",
      phone: "+16372895190",
      country: "Mexico",
      image: "assets/img/supplier/supplier-02.png",
       status:"Active",
    },
    {
      id: "3",
      supplierName: "Dazzle Shoes",
      code: "203",
      email: "dazzleshoes@example.com",
      phone: "+17589201739",
      country: "France",
      image: "assets/img/supplier/supplier-03.png",
       status:"Active",
    },
    {
      id: "4",
      supplierName: "Best Accessories",
      code: "204",
      email: "bestaccessories@example.com",
      phone: "+18934092467",
      country: "Italy",
      image: "assets/img/supplier/supplier-04.png",
       status:"Active",
    },
    {
      id: "5",
      supplierName: "A-Z Store",
      code: "205",
      email: "atozstore@example.com",
      phone: "+12568749035",
      country: "Belgium",
      image: "assets/img/supplier/supplier-05.png",
       status:"Active",
    },
    {
      id: "6",
      supplierName: "Hatimi Hardwares",
      code: "206",
      email: "hatimihardwares@example.com",
      phone: "+19054674627",
      country: "Austria",
      image: "assets/img/supplier/supplier-06.png",
       status:"Active",
    },
    {
      id: "7",
      supplierName: "Aesthetic Bags",
      code: "207",
      email: "aestheticbags@example.com",
      phone: "+18943670365",
      country: "India",
      image: "assets/img/supplier/supplier-07.png",
       status:"Active",
    },
    {
      id: "8",
      supplierName: "Alpha Mobiles",
      code: "208",
      email: "alphamobiles@example.com",
      phone: "+16473894103",
      country: "Greece",
      image: "assets/img/supplier/supplier-08.png",
       status:"Active",
    },
    {
      id: "9",
      supplierName: "Sigma Chairs",
      code: "209",
      email: "sigmachairs@example.com",
      phone: "+17590274536",
      country: "Japan",
      image: "assets/img/supplier/supplier-09.png",
       status:"Active",
    },
    {
      id: "10",
      supplierName: "Zenith Bags",
      code: "210",
      email: "zenithbags@example.com",
      phone: "+12564098473",
      country: "China",
      image: "assets/img/supplier/supplier-10.png",
       status:"Active",
    },
    {
      id: "11",
      supplierName: "Aesthetic Bags",
      code: "211",
      email: "aestheticbags@example.com",
      phone: "+18943670365",
      country: "India",
      image: "assets/img/supplier/supplier-07.png",
       status:"Active",
    },
    {
      id: "12",
      supplierName: "A-Z Store",
      code: "212",
      email: "atozstore@example.com",
      phone: "+12568749035",
      country: "Angola",
      image: "assets/img/supplier/supplier-05.png",
       status:"Active",
    },
    {
      id: "13",
      supplierName: "Dazzle Shoes",
      code: "213",
      email: "dazzleshoes@example.com",
      phone: "+17589201739",
      country: "Albania",
      image: "assets/img/supplier/supplier-03.png",
       status:"Active",
    }
  ]
  